import { useHistory } from 'react-router-dom'

export const useWasBackNavigation = () => {
  const history = useHistory()
  return history.length > 1 && history.action === 'POP'
}
